import {message, Spin, Switch} from "antd";
import {SActionBtn, SFuncModal, SLowcodeList, SMessage, STableActions} from "shj-components";
import {config} from "./config.tsx";
import EditContent, {EditConfig, LevelContent, OneContent} from "./edit.tsx";
import {useRequest, useSetState} from "ahooks";
import {useRef} from "react";
import {
    deleteMemberEvent,
    queryMemberConfigurationList,
    queryMemberEventListByPage,
    updateState
} from "@/services/member.ts";
import {tableApiFunc} from "@/utils/data.ts";
import {getPlatformDict} from "@/services/homeService.ts";

const stateList = [{label: '启用', value: true}, {label: '停用', value: false}]

/**
 *
 * 会员事件库
 * @constructor
 */
function Page() {

    const tableRef = useRef<any>()
    const [state, setState]: any = useSetState({edit: false, config: false, data: null, dictData: []});

    const {runAsync: runAsyncInfo, loading} = useRequest(queryMemberConfigurationList, {manual: true});

    const onChangeStatus = (checked, id) => {
        SMessage.confirm({
            title: checked ? '启用操作' : '禁用操作',
            content: `确定继续操作吗？`,
            onOk: async () => {
                try {
                    await updateState({id, state: checked})
                    tableRef.current.reload()
                } catch (e) {
                    console.log(e)
                }
            },
        })
    }

    const onAddOrEdit = (data: any = {}) => {
        setState({edit: true, data: data});
    }
    const onCancel = (key: string, success: boolean) => {
        setState({[key]: false});
        if (success) {
            message.success('配置成功')
            tableRef.current.reload()
        }
    }
    const onDelete = (id) => {
        deleteMemberEvent({id}).then(() => {
            message.success('删除成功')
            tableRef.current.reload()
        })
    }
    const onConfigEdit = (data: any, type: string) => {
        const memberEventId = data?.type;
        data = {
            ...data,
            memberEventId: data.type,
            type,
        }
        if (memberEventId === 'zeroClear' || memberEventId === 'grant') {
            message.warning('该类型事件无法配置');
            return
        }
        runAsyncInfo({type, memberEventId: data.id}).then(values => {
            const title = type == '1' ? '积分配置' : '成长值配置'
            if (memberEventId == 'firstJoin' || memberEventId == 'birthDay' || memberEventId == 'gradation') {
                const destroy = (success?: boolean) => {
                    modal.destroy()
                    if (success) {
                        message.success('配置成功')
                        tableRef.current.reload()
                    }
                }
                let content = (<LevelContent destroy={destroy} data={data} edit={values}/>);
                if (memberEventId == 'firstJoin') {
                    content = (<OneContent destroy={destroy} data={data} edit={values}/>);
                }

                const modal = SFuncModal({
                    content: content,
                    title: title,
                    vanish: true,
                });
            } else if (data.id) {
                setState({config: true, data: {...data, edit: values, title}});
            }
        })
    }

    const getStatusOptions = async () => {
        const dictData: any = await getPlatformDict('memberEvent');
        setState({dictData});
        return Promise.resolve({
            stateList: stateList,
            memberEvent: dictData
        })
    }
    const extensions = {
        request: {
            fetchList: tableApiFunc(queryMemberEventListByPage, {
                paginationInBody: true,
                fieldNames: {current: 'current'},
            }),
            getStatusOptions,
        },
        events: {onAdd: () => onAddOrEdit()},
        customRender: {
            switchRender(v: boolean, record: Record<string, any>) {
                return <Switch checked={v} onClick={(checked) => onChangeStatus(checked, record.id)}/>
            },
            grantRender(v: any) {
                return v ? '固定' : '不固定';
            },
            actionRender(_: null, record: Record<string, any>) {
                return (
                    <STableActions>
                        <SActionBtn disabled={record.state} onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
                        <SActionBtn disabled={record.state} isDelete onClick={() => onDelete(record.id)}>删除</SActionBtn>
                        <SActionBtn onClick={() => onConfigEdit(record, '1')}>积分配置</SActionBtn>
                        <SActionBtn onClick={() => onConfigEdit(record, '2')}>成长值配置</SActionBtn>
                    </STableActions>
                )
            }
        }
    }
    return (
        <Spin spinning={loading}>
            <div>
                <EditContent data={state.data} dictData={state.dictData} open={state.edit}
                             onClose={(success) => onCancel('edit', success)} title={'新增/编辑'}/>
                <EditConfig data={state.data} type={state.data?.type} open={state.config} onClose={(success) => onCancel('config', success)}/>
                <SLowcodeList
                    searchMode={'group'}
                    config={config}
                    ref={tableRef}
                    {...extensions}
                />
            </div>
        </Spin>
    );
}

export default Page;
